import React from "react";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { APP_NAME } from "../../config";

function AdminFooter() {
  return (
    <>
      <footer className="footer public">
        <div className="bg-primary p-1 mb-3">
          {/* Suicide Prevention Support: */}
          <p className="text-light text-center mb-0">
            If you are in a mental health crisis, call
            <a
              href="https://988lifeline.org/"
              target="_blank"
              className="mx-2 text-light"
              style={{ fontSize: "20px" }}
              rel="noopener noreferrer"
            >
              988
            </a>
            immediately
          </p>
          {/* has been designated as the new three-digit dialing code that will
                   route callers to the National Suicide Prevention Lifeline */}
        </div>

        <div className="d-flex align-items-center justify-content-between w-100 flex-lg-row flex-column flex-wrap">
          <span className="text-center text-lg-left">
            &copy; 2025 {APP_NAME}
          </span>
          <div
            className="d-flex align-items-center fs-16"
            style={{ gap: "20px" }}
          >
            <a
              href="https://www.facebook.com/HamCoIndiana"
              target="_blank"
              rel="noopener noreferrer"
            >
              Facebook
            </a>
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/terms-of-service">Terms of Service</Link>
          </div>

          <span className="powered-by" style={{ color: "#333" }}>
            Powered by{" "}
            <a
              href="https://logic-square.com/"
              target="_blank"
              className="ml-2"
              rel="noopener noreferrer"
            >
              Logic Square
            </a>
          </span>
        </div>
      </footer>
    </>
  );
}

export default AdminFooter;
